<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{
  icon?: Component;
  count: number;
  label: string;
  text: string;
}>();
</script>

<template>
  <component
    :is="icon"
    v-if="icon"
    :width="24"
    :height="24"
  />
  <span
    v-if="count > 0"
    class="rail__badge"
    :title="label"
    :aria-label="label"
    >{{ text }}</span
  >
</template>

<style scoped>
@reference "../../../tailwind.css";

/* Бейдж числа неотвеченных: светлая пилюля у верхне-правого угла бокса иконки — акцент занят выбранным разделом. */
.rail__badge {
  position: absolute;
  top: -4px;
  right: -4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--text-primary);
  color: var(--surface-card);
  box-shadow: 0 0 0 2px var(--sidebar-rail-bg);
  @apply text-2xs;
  font-weight: 600;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
</style>
